import { datadogRum } from '@datadog/browser-rum';
import { isProd, ifProd } from './env';

const sampleRate = ifProd(50, 100);
const premiumSampleRate = 0;
const env = ifProd('production', 'staging');
const version = process.env.BUILD_ID;

export const initDatadogLogs = () => {
  const { DD_TOKEN } = process.env;
  const { DD_LOGS } = window ?? {};

  if (!DD_LOGS || !DD_TOKEN) return;

  DD_LOGS.init({
    clientToken: DD_TOKEN,
    env,
    forwardErrorsToLogs: isProd(),
    sampleRate: 100,
    service: 'aurora-browser',
    version,
  });
};

export const initDatadogRum = () => {
  const { RUM_DD_TOKEN } = process.env;
  if (!RUM_DD_TOKEN) return;

  datadogRum.init({
    allowedTracingUrls: [/https?:\/\/.*([^accounts])\.kueski(pay)?\.(com|codes)/],
    applicationId: 'f40f911a-1fd2-43fd-8bb1-373d63633f8c',
    clientToken: RUM_DD_TOKEN,
    defaultPrivacyLevel: 'mask',
    env,

    premiumSampleRate,

    // Props' name are constantly changing, adding all the know variants
    replaySampleRate: premiumSampleRate,
    sampleRate,
    service: 'aurora-app',
    sessionReplaySampleRate: premiumSampleRate,
    sessionSampleRate: sampleRate,
    site: 'datadoghq.com',
    storeContextsAcrossPages: true,
    trackInteractions: true,
    trackLongTasks: true,
    trackResources: true,
    version,
  });

  if (isProd() && premiumSampleRate > 0) datadogRum.startSessionReplayRecording();
};
